/**
 * 文件说明: 按员工查看
 * ----------------------------------------
 * 创建用户: 1625
 * 创建日期 2021/02/04
 */

import _ from 'lodash'
import {createProjectModel} from 'crm/utils/project-model'
import {getList, exportData} from './service'

const model = createProjectModel({
    projectNamespace: 'messagesDetailByEmployee',
    state: {
        tableList: {}, //  客户列表
        summary: [], //
    },

    effects: {
        *exportTableListData(__, {select, call}) {
            const {tableList} = yield select((allState) => allState[model.namespace])
            const newParams = {
                id: tableList.params?.id,
                body: {
                    ...tableList.params,
                },
            }

            const res = yield call(exportData, newParams)

            return res
        },
        *getTableList(__, {select, put, call}) {
            const {tableList} = yield select((allState) => allState[model.namespace])
            const newParams = {
                offset: tableList.pagination.pageSize * (tableList.pagination.current - 1),
                limit: tableList.pagination.pageSize,
                ...tableList.params,
            }
            const res = yield call(getList, {
                ...newParams,
            })
            res.data.forEach((item, idx) => {
                if (!item.id) {
                    item.id = idx + 1
                }
            })
            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableList.dataSource = res.data
                    draft.tableList.pagination.total = _.get(res, 'pagination.rows_found', 0)
                },
            })
        },
    },
})
export default model
